<div class="min-h-screen bg-gradient-to-br from-gray-50 to-white">
  <!-- Header Section -->
  <section class="bg-gradient-to-r from-brand-primary to-brand-accent text-white py-16">
    <div class="container mx-auto px-4">
      <h1 class="text-5xl font-bold mb-4 text-center">Kontakt</h1>
      <p class="text-xl text-center opacity-90">
        Wir freuen uns auf Ihre Nachricht
      </p>
    </div>
  </section>

  <!-- Contact Content -->
  <section class="py-16">
    <div class="container mx-auto px-4">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          <!-- Contact Information -->
          <div class="space-y-8">
            <div>
              <h2 class="text-3xl font-bold mb-6 text-brand-primary">Kontaktinformationen</h2>
              <p class="text-gray-700 mb-8 leading-relaxed">
                Sie haben Fragen zu unserer mobilen Videowand oder möchten ein individuelles Angebot? 
                Kontaktieren Sie uns – wir beraten Sie gerne!
              </p>
            </div>

            <!-- Contact Details -->
            <div class="space-y-6">
              <div class="flex items-start">
                <div class="bg-brand-accent/10 p-4 rounded-lg mr-4">
                  <svg class="w-6 h-6 text-brand-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                </div>
                <div>
                  <h3 class="font-bold text-lg text-gray-900 mb-1">Telefon</h3>
                  <p class="text-gray-700">+49 (34298) 158673</p>
                </div>
              </div>

              <div class="flex items-start">
                <div class="bg-brand-accent/10 p-4 rounded-lg mr-4">
                  <svg class="w-6 h-6 text-brand-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                <div>
                  <h3 class="font-bold text-lg text-gray-900 mb-1">E-Mail</h3>
                  <a href="mailto:info@videowand-leipzig.de" class="text-brand-accent hover:underline">
                    info&#64;videowand-leipzig.de
                  </a>
                  <p class="text-sm text-gray-500 mt-1">Wir antworten innerhalb von 24 Stunden</p>
                </div>
              </div>

              <div class="flex items-start">
                <div class="bg-brand-accent/10 p-4 rounded-lg mr-4">
                  <svg class="w-6 h-6 text-brand-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <div>
                  <h3 class="font-bold text-lg text-gray-900 mb-1">Adresse</h3>
                  <p class="text-gray-700">
                    Videowand Leipzig | Inhaber Jan Waschke<br>
                    Nikolaus-Lenau-Str. 15<br>
                    04425 Taucha
                  </p>
                </div>
              </div>


            </div>


          </div>

          <!-- Contact Form -->
          <div class="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <h2 class="text-3xl font-bold mb-6 text-brand-primary">Senden Sie uns eine Nachricht</h2>
            
            <form (ngSubmit)="onSubmit()" #contactFormRef="ngForm" *ngIf="!submitted">
              <div class="space-y-4">
                <div>
                  <label for="name" class="block text-sm font-semibold text-gray-700 mb-2">
                    Name <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    [(ngModel)]="contactForm.name"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-accent focus:border-transparent transition"
                    placeholder="Ihr Name"
                  />
                </div>

                <div>
                  <label for="email" class="block text-sm font-semibold text-gray-700 mb-2">
                    E-Mail <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    [(ngModel)]="contactForm.email"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-accent focus:border-transparent transition"
                    placeholder="ihre.email@beispiel.de"
                  />
                </div>

                <div>
                  <label for="phone" class="block text-sm font-semibold text-gray-700 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    [(ngModel)]="contactForm.phone"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-accent focus:border-transparent transition"
                    placeholder="+49 (0) 123 456789"
                  />
                </div>

                <div>
                  <label for="subject" class="block text-sm font-semibold text-gray-700 mb-2">
                    Betreff
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    [(ngModel)]="contactForm.subject"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-accent focus:border-transparent transition"
                    placeholder="Anfrage zur Videowand-Miete"
                  />
                </div>

                <div>
                  <label for="message" class="block text-sm font-semibold text-gray-700 mb-2">
                    Nachricht <span class="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    [(ngModel)]="contactForm.message"
                    required
                    rows="5"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-accent focus:border-transparent transition resize-none"
                    placeholder="Beschreiben Sie Ihr Anliegen..."
                  ></textarea>
                </div>

                <div class="pt-4">
                  <button
                    type="submit"
                    [disabled]="!isFormValid() || loading"
                    class="w-full bg-gradient-to-r from-brand-primary to-brand-accent text-white font-bold px-8 py-4 rounded-lg hover:shadow-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span *ngIf="!loading">Nachricht senden</span>
                    <span *ngIf="loading" class="flex items-center justify-center gap-2">
                      <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Wird gesendet...
                    </span>
                  </button>
                </div>

                <p class="text-sm text-gray-500 text-center">
                  <span class="text-red-500">*</span> Pflichtfelder
                </p>
              </div>
            </form>

            <!-- Success Message -->
            <div *ngIf="submitted" class="text-center py-12">
              <div class="bg-green-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
                <svg class="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              </div>
              <h3 class="text-2xl font-bold text-gray-900 mb-3">Vielen Dank!</h3>
              <p class="text-gray-700">
                Ihre Nachricht wurde erfolgreich gesendet.<br>
                Wir melden uns in Kürze bei Ihnen.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>
